import './index.css';

export default {
  name: 'Aiframe',
  props: {
    id: { type: String, default: () => (`a-iframe-${Math.random().toString().substring(2)}`) },
    component: { type: String, default: () => null },
    element: { type: String, default: () => null },
    page: { type: String, default: () => null },
    path: { type: String, default: () => null },
    link: { type: String, default: () => null },
    url: { type: String, default: () => null },
    data: { type: Object, default: () => null },
    flex: { type: Boolean, default: () => true },
  },
  data() {
    const { loading = true } = this.$attrs;
    return {
      src: null,
      loading,
    };
  },
  watch: {
    component() { this.create() },
    element() { this.create() },
    page() { this.create() },
    path() { this.create() },
    url() { this.create() },
  },
  created() {
    this.create();
  },
  mounted() {
    this.assign();
  },
  destroyed() {
    this.revoke();
  },
  methods: {
    create() {
      this.revoke();
      this.$nextTick(() => {
        this.src = this.component || this.element || this.page || this.path || this.link || this.url;
      });
    },
    assign() {
      this.$nextTick(() => this.$refs.Aiframe.contentWindow.postMessage(this.data, '*'));
    },
    onload() {
      this.$nextTick(() => this.loading = false);
    },
    revoke() {
      this.src = null;
    },
  },
  render() {
    const { ...attrs } = this.$attrs;
    return (
      <div v-loading={this.loading} class={['a-iframe', (this.flex ? 'flex' : null)]}>
        <iframe
          ref="Aiframe"
          id={this.id}
          src={this.src}
          class={['a-iframe-main', (this.loading ? 'loading' : null)]}
          frameborder="0"
          width="100%"
          height="100%"
          scrolling="auto"
          on-load={this.onload}
          attrs={attrs}
        />
      </div>
    );
  }
}